<div class="my-applications-page">
  <app-quota-header [quotaCount]="totalElements" [activeTab]="'my'"></app-quota-header>

  <div class="container">
    @if (loading) {
      <div class="loading">
        <div class="spinner"></div>
        <p>Загрузка заявок...</p>
      </div>
    } @else if (error) {
      <div class="error">
        <p>{{ error }}</p>
        <button (click)="retry()">Повторить</button>
      </div>
    } @else if (applications.length === 0) {
      <div class="empty-state">
        <p>У вас пока нет заявок на квоты</p>
      </div>
    } @else {
      <div class="applications-wrapper">
        @for (app of applications; track app.id) {
          <app-application-card [application]="app" />
        }
      </div>

      @if (totalPages > 1) {
        <div class="pagination">
          <p>Показано {{ applications.length }} из {{ totalElements }} заявок</p>
        </div>
      }
    }
  </div>
</div>
